// components
import { Form, Input } from "antd";
import { Head } from "components/molecules/Head/Head";
import { useAdhocReportPage } from "containers/AdhocReportGeneration/useAdhocReport";
import Label from "components/atoms/Label/Label";
import Button from "components/atoms/Button/Button";
import Spinner from "components/atoms/Spinner/Spinner";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";

// styles
import styles from "containers/AdhocReportGeneration/adhocReportPage.module.css";

// constants
import { ADHOC_REPORTS as Constants, PageTitles } from "constants/global";

const AdhocReportPage = () => {
	const { fileLocation, fileLocationError, form, proceedToExportReport, handleSMFileLocation, loading } = useAdhocReportPage();

	const locationCls = fileLocationError ? styles?.err : styles?.filled;

	return (
		<div className="min-h-screen relative">
			{loading && <Spinner type="transparent" />}
			<PageTitle title={Constants.PAGE_HEADER} subTitle={Constants.PAGE_SUBHEADER} />
			<div className={styles?.root}>
				<Head>{PageTitles.ADHOC_REPORT_GENERATION}</Head>
				<Form className={styles?.form} form={form} requiredMark={false} layout="vertical">
					<Form.Item
						className="mb-auto"
						label={<Label requiredMark label={Constants.SM_LOC_LABEL} classes={{ label: styles?.basic_input_label }} />}
						name={Constants.SM_LOC_LABEL}
						extra={fileLocationError && <ErrorMessage classes={styles?.err_message} message={Constants.FILE_LOCATION_ERROR} />}
					>
						<Input
							className={`${styles?.input_field}  ${fileLocation ? locationCls : ""}`}
							placeholder={Constants.SM_LOC_PLACEHOLDER}
							value={fileLocation}
							onChange={(e) => handleSMFileLocation(e)}
						/>
					</Form.Item>
					<div className={styles.button_wrapper}>
						<Button label={Constants.EXPORT_BUTTON_LABEL} type={fileLocation && !fileLocationError ? "activeLong" : "disabledLong"} onClick={proceedToExportReport} />
					</div>
				</Form>
			</div>
		</div>
	);
};

export default AdhocReportPage;
